import React from 'react';
import { func, array } from 'prop-types';

import {
  Wrapper,
  Box,
  ApplicationLink,
  ApplicationLinkImage,
  ApplicationLinkStatus,
  ApplicationLinkAddressBox,
  ApplicationLinkAddress,
  Title,
} from './styles';

ApplicationPicker.propTypes = {
  applications: array.isRequired, //  eslint-disable-line
  pickApplication: func.isRequired,
};

function ApplicationPicker({ applications, pickApplication }) {
  return (
    <Wrapper>
      <Box>
        <Title>Välj den Bytesansökan du vill komma till.</Title>
        {applications.map(application => {
          if (application.status === 'REMOVED') return null;
          return (
            <ApplicationLink
              key={application.id}
              onClick={() => pickApplication(application.id)}>
              <ApplicationLinkImage url={application.image} />
              <ApplicationLinkAddressBox>
                <ApplicationLinkAddress>
                  {application.addresses[0]}
                </ApplicationLinkAddress>
                <ApplicationLinkAddress>
                  {application.addresses[1]}
                </ApplicationLinkAddress>
                {application.addresses[2] && (
                  <ApplicationLinkAddress>
                    {application.addresses[2]}
                  </ApplicationLinkAddress>
                )}
              </ApplicationLinkAddressBox>
              <ApplicationLinkStatus status={application.status} />
            </ApplicationLink>
          );
        })}
      </Box>
    </Wrapper>
  );
}

export default ApplicationPicker;



// WEBPACK FOOTER //
// ./src/components/ApplicationPicker/ApplicationPicker.js